import axios from 'axios';
// export const testLoc = 'http://chocolate-cms.loc.jet5.ru';
export const testLoc = 'http://macchoco1.loc.jet5.ru';
// export const locOrig = 'http://macchoco1.loc.jet5.ru';
export const locOrig = 'https://macchocolate.ru';

export const HTTP = axios.create({
    baseURL: locOrig,
    timeout: 30000
  });

let pathLang = 'ru';
function langContent(){
  const path = window.location.pathname.split('/');
  pathLang = path[1];
}
langContent();

  export const Routes = {
    footer: `/api/api_footer/`,
    burger_menu: `/api/api_burger_menu/`,
    recipes: `/api/api_recipes/`,
    news: `/api/api_news/`,
    two: `/api/api_two/`,
    prelast: `/api/api_prelast/`,
    one_cookies: `/api/api_one_cookies/`,
    video: `/api/api_video/`,
    title: `/api/api_title/`,
    geo: `/api/api_geo/`,
    score: `/api/api_score/`,
    arrows: `/api/api_custom/`,
    one_social: `/api/api_one_social/`,
    error: `/api/api_crash/`,
    testBurger : `/api/api_burger_menu_test/?lang=${pathLang}`,
    marketplaces: `api/api_markplaces/`
  };
